import React, { SetStateAction } from 'react'
import { StaffAvailability } from '../../components/DropdownSelectors/common'
import { toHHMM } from 'utils/string-localization-helper'
import { Client } from 'types/client'

export interface IAppointmentFormData {
    location: string
    staff: string
    space: string
    date: string
    time: string
    attendees: string
    service: string
}
export const initialFormValues: IAppointmentFormData = {
    location: '',
    staff: '',
    space: '',
    date: new Date().toLocaleDateString('en-ca'),
    time: toHHMM(new Date()),
    attendees: '',
    service: '',
}

export interface ISelectedClient {
    firstName: string
    lastName: string
    email?: string
    id: string
}

export interface IAppointmentDrawer {
    formData: IAppointmentFormData
    setFormData: React.Dispatch<SetStateAction<IAppointmentFormData>>
    attendeeData: any
    setAttendeeData: React.Dispatch<SetStateAction<any>>
    displayAddAttendeeModal: boolean
    setDisplayAddAttendeeModal: React.Dispatch<SetStateAction<boolean>>
    selectedClient: Client | undefined
    setSelectedClient: React.Dispatch<
        SetStateAction<Client | undefined>
    >
    shouldApplyCouponCode: boolean
    setShouldApplyCouponCode: React.Dispatch<SetStateAction<boolean>>
    applyFreeAppointment: boolean
    setApplyFreeAppointment: React.Dispatch<SetStateAction<boolean>>
    couponCode: string
    setCouponCode: React.Dispatch<SetStateAction<string>>
    isValidCouponCode: boolean
    setIsValidCouponCode: React.Dispatch<SetStateAction<boolean>>
    displayNewClientForm: boolean
    setDisplayNewClientForm: React.Dispatch<SetStateAction<boolean>>
    handleAddAttendeeSubmit: any
    isPaymentSuccessFull: boolean
    setIsPaymentSuccessful: React.Dispatch<SetStateAction<boolean>>
    newClientInfo: Client | undefined
    setNewClientInfo: React.Dispatch<
        SetStateAction<Client | undefined>
    >
    selectedMembership: string | undefined
    setSelectedMembership: React.Dispatch<
        SetStateAction<string | undefined>
    >
    err: string
    setErrMsg: React.Dispatch<SetStateAction<string>>
    isSuccess: boolean
    setIsSuccess: React.Dispatch<SetStateAction<boolean>>
    availabilityStatus: StaffAvailability
    setAvailablilityStatus: React.Dispatch<
        SetStateAction<StaffAvailability>
    >
    displayAvailabilityModal: boolean
    setDisplayAvailabilityModal: React.Dispatch<SetStateAction<boolean>>
    couponInfo: any
    setCouponInfo: React.Dispatch<SetStateAction<any>>
}

export const initialValues: IAppointmentDrawer = {
    formData: initialFormValues,
    setFormData: () => initialFormValues,
    attendeeData: {},
    setAttendeeData: () => {},
    displayAddAttendeeModal: false,
    setDisplayAddAttendeeModal: () => false,
    selectedClient: undefined,
    setSelectedClient: () => undefined,
    shouldApplyCouponCode: false,
    setShouldApplyCouponCode: () => false,
    applyFreeAppointment: false,
    setApplyFreeAppointment: () => false,
    couponCode: '',
    setCouponCode: () => '',
    isValidCouponCode: false,
    setIsValidCouponCode: () => false,
    displayNewClientForm: false,
    setDisplayNewClientForm: () => false,
    handleAddAttendeeSubmit: () => {},
    isPaymentSuccessFull: false,
    setIsPaymentSuccessful: () => false,
    newClientInfo: undefined,
    setNewClientInfo: () => undefined,
    selectedMembership: undefined,
    setSelectedMembership: () => undefined,
    err: '',
    setErrMsg: () => '',
    isSuccess: false,
    setIsSuccess: () => false,
    availabilityStatus: StaffAvailability.AVAILABLE,
    setAvailablilityStatus: () => StaffAvailability.AVAILABLE,
    displayAvailabilityModal: false,
    setDisplayAvailabilityModal: () => false,
    couponInfo: undefined,
    setCouponInfo: () => undefined,
}
